import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    standalone: false
})
export class CheckboxComponent {
  @Input() label?: string = '';
  @Input() checked?: boolean;
  @Input() disabled: boolean = false;
}
